import {SVGProps} from 'react';

const Icon = (props: SVGProps<SVGSVGElement>) => (
    <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M9.5 18H4.5C3.94772 18 3.5 17.5523 3.5 17V15.2514C3.5 15.2191 3.51555 15.1889 3.54177 15.1701L5.41279 13.8299C5.43901 13.8111 5.45456 13.7809 5.45456 13.7486V10.0455C5.45456 6.4305 8.38506 3.5 12 3.5V3.5C15.615 3.5 18.5455 6.4305 18.5455 10.0455V13.7459C18.5455 13.7797 18.5625 13.8111 18.5907 13.8296L20.6401 15.1704C20.6683 15.1889 20.6854 15.2203 20.6854 15.2541V17C20.6854 17.5523 20.2376 18 19.6854 18H14.5M9.5 18V19C9.5 20.3807 10.6193 21.5 12 21.5V21.5C13.3807 21.5 14.5 20.3807 14.5 19V18M9.5 18H14.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1.5"
        />
    </svg>
);

export default Icon;
